import styled from 'styled-components';
import { Scrollbars } from "react-custom-scrollbars";
import { Select } from "antd";
import React from 'react';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 360px;
    border-radius: 10px;
`

export const ButtonsBlock = styled.div`
    width: 55px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`

export const Button = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 21px;
    height: 21px;
    background: #629361;
    border: 4px solid #629361;
    border-radius: 5px;

    :hover {
        cursor: pointer;
    }

    :nth-child(n + 2) {
        margin-left: 13px;
    }
`

export const ModalBody = styled(Scrollbars)`
    width: 100%;
    height: 175px;
`

export const Row = styled.div`
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);
`

export const RowContent = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    border-right: 1px solid rgba(98, 147, 97, 0.15);
`
export const ParamName = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const Content = styled.div`
    display: flex;
    padding-left: 15px;
    align-items: center;
    width: 100%;
    height: 40px;

    > div:first-child {
        width: 120px;
        margin-right: 5px;
    }

    > .ant-select > .ant-select-arrow > .ant-select-suffix {
        transition: transform 0.3s ease-in-out;
    }

    > .ant-select-open > .ant-select-arrow > .ant-select-suffix {
        transition: transform 0.3s ease-in-out;
        transform: rotate(180deg) scale(1.5);
    }
`

const _Select = ({
                     suffixIcon,
                     placeholder,
                     options,
                     onChange,
                     defaultValue
                 }) => (
    <Select
        suffixIcon={suffixIcon}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        defaultValue={defaultValue}
    />
)

export const TypeSelect = styled(Select)`
    margin-right: 15px;
    background: rgba(98, 147, 97, 0.1);
    border-radius: 4px;
    font-size: 12px;
    width: 140px;


    div:first-child {
        background-color: rgba(98, 147, 97, 0.1);
    }

    :not(.ant-select-customize-input) .ant-select-selector {
        padding: 0;
        background-color: rgba(98, 147, 97, 0.1);
    }

    & .ant-select-single.ant-select-show-arrow .ant-select-selection-search {
        right: 0;
        left: 0;
        background: rgba(98, 147, 97, 0.1);
    }

    & .ant-select-selector {
        .ant-select-selection-item, .ant-select-selection-placeholder {
            padding-left: 7px;
            color: black;
        }
    }

    &:not(.ant-select-customize-input) .ant-select-selector {
        border: none;
        border-radius: 4px;
    }
`

interface ValueProps {
    onChange?: (e: React.FormEvent<HTMLInputElement>) => void
    error?: boolean
}

export const Value = styled.input<ValueProps>`
    width: 15px;
    flex-grow: 1;

    //position: relative;
    outline: none;
    margin-right: 15px;
    transition: all .3s ease-out;
    border-bottom: 2px solid ${({ theme, error }) => error ? '#BD3636' : theme.color.splitPanel};
`

export const ButtonContainer = styled.div`
    display: flex;
    width: 35px;
    height: 100%;
    margin-right: 5px;
    align-self: flex-end;
    justify-self: flex-end;
    justify-content: center;
    align-items: center;
    border-left: 1px solid rgba(98, 147, 97, 0.15);

    :hover {
        cursor: pointer;
    }
`
